var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fe-flex fe-border fe-border-primary-grey-40 fe-border-solid fe-rounded-pill fe-max-w-fit"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }